import { action, computed, observable } from 'mobx';
import { supplierAccountApi } from '@link/supplier/services';
import { ContractWithOtaAndSupplier } from '@link/supplier/services/types';

export class Contract {
  @observable accessor contract: ContractWithOtaAndSupplier | null = null;

  @action
  async getDetail(contractId: string) {
    const response = await supplierAccountApi.getContractDetail({
      contractId
    });
    if (response.contract) {
      this.setContract(response.contract);
    }
    return response;
  }

  @action
  setContract(contract: ContractWithOtaAndSupplier) {
    this.contract = contract;
  }

  @computed
  get status() {
    return this.contract?.status;
  }

  @computed
  get otaName() {
    return this.contract?.ota?.originalName || '';
  }

  @computed
  get otaCustomId() {
    return this.contract?.ota?.otaCustomId || '';
  }

  @computed
  get supplierName() {
    return this.contract?.supplier?.originalName || '';
  }

  @computed
  get supplierCustomId() {
    return this.contract?.supplier?.supplierCustomId || '';
  }

  @action
  clear() {
    this.contract = null;
  }
}

export default new Contract();
